import { Component, EventListener, GondelBaseComponent } from '@gondel/core';

/**
 * card-image module implementation.
 * @author Nikola Antic <nikola.antic@emea.merkleinc.com>
 */

enum States {
	Opened = 'state-m-card-image--opened',
}

@Component('CardImage')
export class CardImage extends GondelBaseComponent {
	/**
	 * Toggle state opened on card-image
	 * @param event
	 */
	@EventListener('click')
	public _onCardClicked(event: PointerEvent): void {
		this._ctx.classList.toggle(States.Opened);
	}
}
